import React from 'react'
import './middleSide.css'
import storyData from '../story.json'
import Post from '../Post/post'

const MiddleSide = () => {
  const stories = storyData.story

  return (
    <div className='middleHomeSide'>

      {/* ===== STORY SECTION ===== */}
      <div className='storyBlock'>
        {stories.map((item, index) => (
          <div className='storyParticular' key={index}>
            <div className='imageDIV'>
              <img src={item.img} className='StoryIMG' alt='story' />

              <span className='spark star'>⭐</span>
              <span className='spark heart'>❤️</span>
              <span className='spark flower'>🌸</span>
              <span className='spark cele'>🎉</span>

              <span className='spark spark1'>✨</span>
              <span className='spark spark2'>🔥</span>
              <span className='spark spark3'>💫</span>
              <span className='spark spark4'>🧡</span>
            </div>

            <div className='profileName'>{item.name}</div>
          </div>
        ))}
      </div>

      {/* ===== POST SECTION ===== */}
      <div className='postsection'>
        <div className='postWrapper'>
          <Post />
        </div>
      </div>

    </div>
  )
}

export default MiddleSide
